import React, { useCallback, useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import SubNav from "../../../Shared/SubNav";
import socket from "../../../context/socket";
import { Tab1 } from "./Tab1";
import { Tab2 } from "./Tab2";
import { Tab3 } from "./Tab3";
import _ from "lodash";
import { Tab4 } from "./Tab4";
import { useSelector } from "react-redux";

export const PortfolioReview = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  
  const searchParamsType = searchParams.get("type");
  const searchParamsPRFail = searchParams.get("prf");

  const roomId = new URLSearchParams(window.location.search).get("clientId");
  console.log('searchParamsType', searchParamsType,searchParamsPRFail);

  const [selectedMember, setSelectedMember] = useState({});
  // console.log("selectedMember",selectedMember);
  const [isPrsuggections, setPrsuggections] = useState([]);
  const [selectedTab, setSelectedTab] = useState(1);
  const [selectedCards, setSelectedCards] = useState([]);
  // State to keep track of the active tab
  const [activeTab, setActiveTab] = useState("home-tab");
  const [isChecked, setIsChecked] = useState(true);
  const [historyActiveTab, setHistoryActiveTab] = useState("Goals");
  const [rowActions, setRowActions] = useState({});
  const [schemeCode, setSchemeCode] = useState({});


  const TAB_MAP = {
  GE: 'profile-tab',
  PR: 'home-tab',
  EI: 'ei-tab',
  EH: 'Event-tab',
}

const TAB_TO_PARAM = {
  'profile-tab': 'GE',
  'home-tab': 'PR',
  'ei-tab': 'EI',
  'Event-tab': 'EH',
}

useEffect(() => {
  if (!searchParamsType) return

  const tab = TAB_MAP[searchParamsType]
  if (tab) {
    setActiveTab(tab)
  }
}, [searchParamsType])

const handleTabChange = (tabId) => {
  setActiveTab(tabId)
  setSelectedTab(1)
  setIsViewArchivedEvent('')

  const param = TAB_TO_PARAM[tabId]
  if (param) {
    setSearchParams(prev => {
      const next = new URLSearchParams(prev)
      next.set('type', param)
      if (roomId) next.set('clientId', roomId)
      return next
    })
  }
}


//   useEffect(() => {
//     // only when perams having type
//     if (searchParamsType === 'GE') {
//         setActiveTab('profile-tab')
//     } else if (searchParamsType === 'PR') {
//         setActiveTab('home-tab')
//     }else if (searchParamsType === 'EI') {
//         setActiveTab('ei-tab')
//     }else if (searchParamsType === 'EH') {
//         setActiveTab('Event-tab')
//     }

// }, [searchParamsType])




  const {
    clientData,
    loading: clientLoading,
    error: clientError,
  } = useSelector((state) => state.client);
  const [isViewArchivedEvent, setIsViewArchivedEvent] = useState("");



  useEffect(() => {
    socket.emit("join", roomId);
    socket.emit("dataFetch", {
      room: roomId,
      data: { selectedMember },
    });
  }, [roomId, selectedMember]);

  // Debounced function to emit messages
  const debouncedEmitMessage = useCallback(
    _.debounce(() => {
      console.log("historyActiveTab", historyActiveTab)
      // console.log("Emiting message :", activeTab, selectedTab, isPrsuggections);
      socket.emit("gateway", {
        room: roomId,
        data: {
          selectedCards,

          activeTab,
          selectedTab,
          isPrsuggections,
          isChecked,
          historyActiveTab,
          rowActions,
          schemeCode
        },
      });
    }, 300),
    [selectedCards, activeTab, selectedTab, isPrsuggections, historyActiveTab, isChecked, rowActions, schemeCode]
  );

  useEffect(() => {
    debouncedEmitMessage();
  }, [
    selectedCards,
    debouncedEmitMessage,
    selectedTab,
    isPrsuggections,
    selectedMember,
    isChecked, historyActiveTab, rowActions, schemeCode
  ]);

  const handleNext = () => {
    const nextUrl = "/customized-action-plan?clientId=" + roomId;
    socket.emit("navigate", { room: roomId, url: nextUrl });
    navigate(nextUrl);
  };

  const handleBack = () => {
    const prevUrl = "/my-investment?clientId=" + roomId;
    socket.emit("navigate", { room: roomId, url: prevUrl });
    navigate(prevUrl);
  };

  // Function to change the active tab
  // const handleTabChange = (tabId) => {


  //   setActiveTab(tabId);
  //   setSelectedTab(1);
  //   setIsViewArchivedEvent("");
  // };






  useEffect(() => {
    // console.log("checking", isViewArchivedEvent);
    if (isViewArchivedEvent) {
      handleTabChange("profile-tab");
    }
  }, [isViewArchivedEvent]);

  const fetchDate = clientData?.last_ei_fetch_date;
  const portfolioDate = clientData?.last_portfolio_review_date;

  const displayDate = fetchDate || portfolioDate;
  const displayLabel = fetchDate
    ? "Last investments fetched"
    : "Last portfolio review";

  return (
    <>
      <div className="container position-relative minht">
        <div className="row mb-3">
          <div className="col">
            <ul
              className="nav nav-tabs justify-content-start mb-3"
              id="myTab"
              role="tablist"
            >
              <li className="nav-item" role="presentation">
                <button
                  className={`nav-link border-0 navclr ${activeTab === "home-tab" ? "active" : ""
                    }`}
                  id="home-tab"
                  data-bs-toggle="tab"
                  type="button"
                  role="tab"
                  aria-controls="home-tab-pane"
                  aria-selected={activeTab === "home-tab"}
                  onClick={() => handleTabChange("home-tab")}
                >
                  <span className={`fs-21 mt-3 ${activeTab !== "home-tab" && "clrgreen-black"}`}>Portfolio Review</span>
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className={`nav-link border-0 navclr ${activeTab === "ei-tab" ? "active" : ""
                    }`}
                  id="ei-tab"
                  data-bs-toggle="tab"
                  type="button"
                  role="tab"
                  aria-controls="ei-tab-pane"
                  aria-selected={activeTab === "ei-tab"}
                  onClick={() => handleTabChange("ei-tab")}
                >
                  <span className={`fs-21 mt-3 ${activeTab !== "ei-tab" && "clrgreen-black"}`}>EI Review</span>
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className={`nav-link border-0 navclr ${activeTab === "profile-tab" ? "active" : ""
                    }`}
                  id="profile-tab"
                  data-bs-toggle="tab"
                  type="button"
                  role="tab"
                  aria-controls="profile-tab-pane"
                  aria-selected={activeTab === "profile-tab"}
                  onClick={() => handleTabChange("profile-tab")}
                >
                  <span className={`fs-21 mt-3 ${activeTab !== "profile-tab" && "clrgreen-black"}`}>Goal Event</span>
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className={`nav-link border-0 navclr ${activeTab === "Event-tab" ? "active" : ""
                    }`}
                  id="Event-tab"
                  data-bs-toggle="tab"
                  type="button"
                  role="tab"
                  aria-controls="Event-tab-pane"
                  aria-selected={activeTab === "Event-tab"}
                  onClick={() => {
                    handleTabChange("Event-tab");
                  }}
                >
                  <span className={`fs-21 mt-3 ${activeTab !== "Event-tab" && "clrgreen-black"}`}>Event History</span>
                </button>
              </li>
              <li className="ms-auto mt-2">
                {displayDate && (
                  <p className="m-0">
                    {displayLabel} -{" "}
                    {new Date(displayDate).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                    })}
                  </p>
                )}
              </li>

            </ul>




            {/* Conditionally render tab content */}


            {activeTab === "home-tab" && (
              <Tab1
                rowActions={rowActions} setRowActions={setRowActions}
                schemeCode={schemeCode} setSchemeCode={setSchemeCode}
                selectedTab={selectedTab}
                setSelectedTab={setSelectedTab}
                setSelectedCards={setSelectedCards}
                selectedCards={selectedCards}
                setPrsuggections={setPrsuggections}
                isPrsuggections={isPrsuggections}
                setSelectedMember={setSelectedMember}
                selectedMember={selectedMember}
                setIsChecked={setIsChecked}
                isChecked={isChecked}
                setHistoryActiveTab={setHistoryActiveTab}
                setActiveTab={setActiveTab}
                searchParamsPRFail={searchParamsPRFail}
              />
            )}
            {activeTab === "profile-tab" && (
              <Tab2 roomId={roomId} isViewArchivedEvent={isViewArchivedEvent} />
            )}
            {activeTab === "Event-tab" && (
              <Tab3 setIsViewArchivedEvent={setIsViewArchivedEvent} historyActiveTab={historyActiveTab} setHistoryActiveTab={setHistoryActiveTab} />
            )}
            {activeTab === "ei-tab" && (
              <Tab4
                roomId={roomId}
                isViewArchivedEvent={isViewArchivedEvent}
                setSelectedTab={setSelectedTab}
                selectedTab={selectedTab}
              />
            )}
          </div>
        </div>
      </div>

      {/* <div className="row mt-md-3 mt-4">
        <div className="col">
          <div className="container">
            <div className="row my-4">
              <div className="col text-end">
                <a href="javascript:void(0);" onClick={handleBack}>
                  <img
                    className="arrow_next1"
                    src="assets/images/left-arrowpng.png"
                    alt=""
                  />
                </a>
                <a href="javascript:void(0);" className="ms-1" onClick={handleNext}>
                  <img
                    className="arrow_next"
                    src="assets/images/right-arrow.svg"
                    alt=""
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div> */}
    </>
  );
};
